/**
 * UTF-16 Encoding.
 *
 * @group Utils
 *
 * @beta
 */
export const UTF_16 = 'utf-16';
